import { onBeforeUnmount, ref } from 'vue';

export default function useCurrentTime() {
  const currentTime = ref(new Date());
  const currentTimeInterval = ref(
    window.setInterval(() => {
      currentTime.value = new Date();
    }, 2000),
  );
  onBeforeUnmount(() => window.clearInterval(currentTimeInterval.value));
  return {
    currentTime,
  };
}
